// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition20Filled: FC<Recognition20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path
                d="M10 1.444a6.751 6.751 0 0 1 5.269 10.968l2.242 3.882-3.425.47-2.12 2.733L10 16.09l-1.966 3.406-2.119-2.733-3.425-.47 2.241-3.882A6.751 6.751 0 0 1 10 1.444ZM4.904 15.112l1.518.208.303.042.187.241.939 1.21 1.124-1.946a6.717 6.717 0 0 1-3.142-1.365l-.929 1.61Zm9.263-1.61a6.716 6.716 0 0 1-3.142 1.365l1.123 1.946 1.127-1.451.304-.042 1.517-.208-.929-1.61ZM9.097 9.06 7.517 7.478 6.456 8.54l2.642 2.642.53-.53L13.37 6.91l-1.06-1.06-3.211 3.21Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Recognition20Filled;
